import React from "react";
var __jsx = React.createElement;
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { timeFormat } from "./index";
import { StyledItemContainer, StyledItemRow, StyledDateLabel, StyledStatusText, StyledInsufficientText } from "./styled";

var InsufficientItem = _ref => {
  var trade = _ref.trade;
  var createdAt = trade.createdAt,
      status = trade.status;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return __jsx(StyledItemContainer, null, __jsx(StyledItemRow, null, __jsx(StyledDateLabel, null, dayjs(createdAt).format(timeFormat)), __jsx(StyledStatusText, {
    color: "#FD5939"
  }, t('best_buy_trade_status_no_trading_occurred'))), __jsx(StyledInsufficientText, null, t("best_buy_trade_status_".concat(status))));
};

export default InsufficientItem;